export default __webpack_public_path__ + "static/media/Best-Prices-Offers.cea3a89a.png";